export type ProfileSectionGroupId = 'identity' | 'family' | 'qualifications' | 'visaPath';

export interface ProfileSectionMeta {
    key: string;
    label: string;
    form: string;
    group: ProfileSectionGroupId;
    disabledWhenEditing?: boolean;
    disabledTooltip?: string;
}

export const PROFILE_SECTION_GROUPS: { id: ProfileSectionGroupId; labelKey: string }[] = [
    { id: 'identity', labelKey: 'profileGroupIdentity' },
    { id: 'family', labelKey: 'profileGroupFamily' },
    { id: 'qualifications', labelKey: 'profileGroupQualifications' },
    { id: 'visaPath', labelKey: 'profileGroupVisaPath' },
];
